"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./GlobalFooter.css");
require("./GlobalFooter.mobile.css");
// removed file from here
var cards_1 = require("./cards");
var utils_1 = require("../../../utils/utils");
var GlobalFooter = /** @class */ (function (_super) {
    __extends(GlobalFooter, _super);
    function GlobalFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalFooter.prototype.render = function () {
        var cssClasses = [styles.globalFooter];
        return (React.createElement("div", { "data-test-id": this.props.testId, className: cssClasses.join(' ') },
            React.createElement("div", { className: styles.orangeBar }, "\u00A0"),
            React.createElement("div", { className: styles.container },
                React.createElement(cards_1.default, { testId: utils_1.default(this.props.testId, 'FooterLinks') }))));
    };
    return GlobalFooter;
}(React.Component));
exports.default = GlobalFooter;
//# sourceMappingURL=GlobalFooter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/GlobalFooter.js
// module id = 1378
// module chunks = 8